import useData from "./useData";
import config from "../../config/apiService.json";

const useService = (id) => {
  const { home } = config;
  const { services } = home;
  const response = useData(`${services}/${id}`);
  return response;
};
export default useService;
